import { CSSProperties } from 'react';

export const listStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column-reverse' as const,
  padding: '10px 10px 10px 10px',
  position: 'relative' as const
};
